import { api } from './api';

export const userService = {
    /**
     * Registers a new member.
     */
    registerMember: async (memberData) => {
        const formData = new FormData();

        const appendIfDefined = (key, value) => {
            if (value !== undefined && value !== null && value !== '') {
                formData.append(key, String(value));
            }
        };

        const convertDateFormat = (dateStr) => {
            const parts = dateStr.split('/');
            if (parts.length === 3) {
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateStr;
        };

        appendIfDefined('UserId', memberData.userId);
        appendIfDefined('FullName', memberData.fullName);
        appendIfDefined('Mobile', memberData.mobileNumber);
        appendIfDefined('DateOfBirth', convertDateFormat(memberData.dob));
        appendIfDefined('Gender', memberData.gender);
        appendIfDefined('BloodGroup', memberData.bloodGroup);
        appendIfDefined('Occupation', memberData.occupation);
        appendIfDefined('ConstituencyId', memberData.constituencyId);
        appendIfDefined('Constituency', memberData.constituencyName);
        appendIfDefined('Address', memberData.address);
        appendIfDefined('AffiliatedInOtherParties', String(memberData.affiliatedInOtherParties));
        appendIfDefined('ReferralCode', memberData.referralCode);

        formData.append('Relationship', memberData.relationship || '');
        formData.append('RelationType', memberData.relationType || '');
        formData.append('RelationId', memberData.relationId || '');
        if (memberData.idProof) {
            if (memberData.idProof instanceof File) {
                formData.append('IdProofPicPath', memberData.idProof);
            } else if (memberData.idProof.uri) {
                formData.append('IdProofPicPath', memberData.idProof);
            }
        }

        if (memberData.profilePhoto) {
            if (memberData.profilePhoto instanceof File) {
                formData.append('ProfilePicPath', memberData.profilePhoto);
            } else if (memberData.profilePhoto.uri) {
                formData.append('ProfilePicPath', memberData.profilePhoto);
            }
        }

        return api.post('/user-profile', formData);
    },

    /**
     * Creates a new user profile with simplified payload.
     */
    createProfile: async (profileData) => {
        // Based on new requirement: JSON payload with fullName, mobile, role
        const payload = {
            fullName: profileData.fullName,
            mobile: profileData.mobile,
            role: Number(profileData.role || 2)
        };

        return api.post('/users', payload);
    },


    getUsers: async (pageNumber = 1, pageSize = 10, search = '') => {
        return api.get(`/users?PageNumber=${pageNumber}&PageSize=${pageSize}&Search=${search}`);
    },


    getUserById: async (userId) => {
        return api.get(`/user-profile/${userId}`);
    },


    getUserRelations: async (userId) => {
        return api.get(`/users/relations/${userId}`);
    },


    updateUser: async (
        userId,
        userData,
        profilePic,
        idProofPic
    ) => {
        const formData = new FormData();

        // Helper to append if defined
        const appendIfDefined = (key, value) => {
            if (value !== undefined && value !== null) {
                formData.append(key, String(value));
            }
        };

        appendIfDefined('UserId', userId);
        appendIfDefined('FullName', userData.fullName);
        appendIfDefined('Mobile', userData.mobile);

        // Gender and BloodGroup are REQUIRED by backend - always send them
        formData.append('Gender', String(userData.gender || ''));
        formData.append('BloodGroup', String(userData.bloodGroup || ''));

        appendIfDefined('Address', userData.address);
        appendIfDefined('DateOfBirth', userData.dateOfBirth);
        appendIfDefined('Occupation', userData.occupation);

        // Correct field name for Constituency ID
        if (userData.constituencyId !== undefined) {
            formData.append('ConstituencyId', String(userData.constituencyId));
        }

        formData.append('AffiliatedInOtherParties', String(userData.affiliatedInOtherParties || false));

        // Handle Profile Pic
        if (profilePic) {
            if (profilePic instanceof File) {
                formData.append('ProfilePicPath', profilePic);
            } else if (profilePic.file instanceof File) {
                formData.append('ProfilePicPath', profilePic.file);
            } else if (profilePic.uri) {
                formData.append('ProfilePicPath', profilePic);
            }
        }

        // Handle ID Proof Pic
        if (idProofPic) {
            if (idProofPic instanceof File) {
                formData.append('IdProofPicPath', idProofPic);
            } else if (idProofPic.file instanceof File) {
                formData.append('IdProofPicPath', idProofPic.file);
            } else if (idProofPic.uri) {
                formData.append('IdProofPicPath', idProofPic);
            }
        }

        // Create a plain object for logging (since FormData is opaque in logs)
        const logData = {};

        if (formData._parts) {
            logData.parts = formData._parts;
        } else {
            // Browser/Standard FormData iteration if available
            for (let pair of formData.entries()) {
                logData[pair[0]] = pair[1];
            }
        }
        console.log('Update User Payload (FormData parts):', JSON.stringify(logData));

        return api.post(`/user-profile/${userId}`, formData);
    },


    deleteUser: async (userId) => {
        return api.delete(`/users/${userId}`);
    }
};
